import {
  Component,
  effect,
  OnInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { fromEvent } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { SmartSmsShareMemoryService } from 'src/app/core/services/smart-sms-shareMemory.service';
import { ShortLinkModalComponent } from 'src/app/pages/content-management/short-links/short-link-modal/short-link-modal.component';
import { AppDomService } from '../../../core/services/dom.service';
import {
  GetVoiceMessagesListDto,
  SmsCp,
  SocialMediaApplicationsListDto,
  SocialMediaMessageFilesForSendDto,
} from './../../../core/api/models';
import { SendTypes } from './../../../core/api/models/send-types';
import { PermissionService } from './../../../core/services/authentication/permission.service';
import {
  DialogService,
  DialogStatus,
} from './../../../core/services/dialog.service';
import { UtilityService } from './../../../core/services/utility.service';
import { SmsTemplateModalComponent } from './../sms-template-modal/sms-template-modal.component';
import { SmsBodyHeaderComponent } from './sms-body-header/sms-body-header.component';
import { SmsBodyProperties } from './sms-body-properties.component';
import { SmsBodySignatureComponent } from './sms-body-signature/sms-body-signature.component';
import { SmsPreviewComponent } from './sms-preview/sms-preview.component';

@Component({
  selector: 'app-sms-body',
  templateUrl: './sms-body.component.html',
  styleUrls: ['./sms-body.component.scss'],
  standalone: false,
})
export class SmsBodyComponent extends SmsBodyProperties implements OnInit {
  constructor(
    protected utilityService: UtilityService,
    protected dialogService: DialogService,
    protected permissionService: PermissionService,
    protected smartSmsShareMemory: SmartSmsShareMemoryService,
    protected renderer: Renderer2,
    protected translateService: TranslateService
  ) {
    super();
    effect(() => {
      if (this.permissionService.userState()) {
      }
      this.getUserState();
    });
  }

  ngOnInit() {
    // if (this.smsBody) this.smsBody = decodeURIComponent(this.smsBody);

    if (this.socialMediaFileId != null && this.socialMediaFileId != undefined) {
      this.isCanSendSocialMedia = true;
      this.socialMediaMessageDetails.socialMediaApplicationId =
        this.socialMediaApplicationId;
      this.socialMediaMessageDetails.socialMediaFileId = this.socialMediaFileId;
      this.output_senderNumber.emit({ smsCp: SmsCp.Mxb });
    } else if (
      this.voiceMessageId != null &&
      this.voiceMessageId != undefined
    ) {
      this.isCanSendVoice = true;
      this.voiceMessageDetails.voiceMessageId = this.voiceMessageId;
      this.voiceMessageDetails.maxTryCount = this.maxTryCount;
      this.voiceMessageDetails.minuteBetweenTries =
        this.minuteBetweenTries ?? 10;
      this.output_senderNumber.emit({ isCanSendVoice: true });
    }

    if (!this.input_privateNumberType) this.input_privateNumberType = 'default';

    this.getUserState();

    if (this.input_formGroupName)
      this.input_form = this.input_form.controls[
        this.input_formGroupName
      ] as FormGroup;
    if (this.input_disabled) this.input_form.disable();
  }

  ngAfterViewInit(): void {
    this.bindEvents();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['isRefreshForm'] &&
      changes['isRefreshForm'].currentValue == true
    )
      this.clearSmsBody();
  }

  bindEvents() {
    const backdropElement = this.backdropElement();
    if (backdropElement) {
      backdropElement.nativeElement.style.height =
        this.smsbodyElement().nativeElement.offsetHeight + 'px';
      backdropElement.nativeElement.style.width =
        this.smsbodyElement().nativeElement.offsetWidth + 'px';

      fromEvent(this.smsbodyElement().nativeElement, 'mousedown').subscribe(
        (res) => {
          this.backdropElement().nativeElement.style.display = 'none';
        }
      );

      fromEvent(this.smsbodyElement().nativeElement, 'mouseup').subscribe(
        (res) => {
          const backdropElementValue = this.backdropElement();
          backdropElementValue.nativeElement.style.display = 'initial';

          backdropElementValue.nativeElement.style.height =
            this.smsbodyElement().nativeElement.offsetHeight + 'px';
          backdropElementValue.nativeElement.style.width =
            this.smsbodyElement().nativeElement.offsetWidth + 'px';
        }
      );
    }
  }

  separateSmsBody() {
    if (!this.smsBody) this.smsBody = '';

    if (this.smsBody.includes(this.organizationSmsHeader))
      this.smsBody = this.smsBody.replace(this.organizationSmsHeader, '');

    if (this.smsBody.includes(this.smsHeader))
      this.smsBody = this.smsBody.replace(this.smsHeader, '');

    if (this.smsBody.includes(this.organizationSignature))
      this.smsBody = this.smsBody.replace(this.organizationSignature, '');

    if (this.smsBody.includes(this.signature))
      this.smsBody = this.smsBody.replace(this.signature, '');

    this.smsBody = this.smsBody;
  }

  onChangeSenderNumberId(senderNumberId: number) {
    if (senderNumberId == null) {
      this.output_senderNumberId.emit(null);
      this.output_senderNumber.emit(null);
      this.sendNumberSelected = null;
      this.smsCount = 0;
      this.voiceMessageDetails = {};
      this.socialMediaMessageDetails = {};
      this.signature = null;
      this.smsHeader = null;
      this.getSmsCount();
      this.emitVoiceMessages();
      this.emitSocialMediaMessages();
      this.emitSmsBody();
      this.emitSmsCount();
      return;
    }

    this.output_senderNumberId.emit(senderNumberId);

    this.getSmsCount();
    this.emitSmsBody();
  }

  onChangeSenderNumber(model: any) {
    if (model == null) {
      this.output_senderNumberId.emit(null);
      this.output_senderNumber.emit(null);
      this.sendNumberSelected = null;
      this.smsCount = 0;
      this.voiceMessageDetails = {};
      this.socialMediaMessageDetails = {};
      this.signature = null;
      this.smsHeader = null;
      this.getSmsCount();
      this.emitVoiceMessages();
      this.emitSocialMediaMessages();
      this.emitSmsBody();
      this.emitSmsCount();
      return;
    }
    //voice message
    this.isCanSendVoice = model.isCanSendVoice;
    this.isCanSendSocialMedia = model.smsCp == SmsCp.Mxb;
    if (this.isCanSendVoice && !this.isEditMode) {
      this.clearSmsBody();
      // this.voiceMessageDetails = { minuteBetweenTries: 30, maxTryCount: 2 };
    } else if (!this.isCanSendVoice) {
      this.voiceMessageDetails = {};
      this.voiceMessageGroupId = null;
      if (!this.isCanSendSocialMedia) this.socialMediaMessageDetails = {};
      this.emitVoiceMessages();
      this.emitSocialMediaMessages();
    }
    if (
      this.input_sendType == SendTypes.Single ||
      this.input_sendType == SendTypes.Phonebook ||
      this.input_sendType == SendTypes.Bulk ||
      this.input_sendType == SendTypes.Bulk2 ||
      this.input_sendType == SendTypes.Smart
    ) {
      //social media message
      if (!this.isCanSendSocialMedia) {
        this.socialMediaMessageDetails = {};
        if (!this.isCanSendVoice) this.voiceMessageDetails = {};
        this.emitSocialMediaMessages();
        this.emitVoiceMessages();
      }
    }

    this.output_senderNumberId.emit(+model.id);
    this.output_senderNumber.emit(model);

    this.privateNumber = model.number;

    this.sendNumberSelected = model;
    this.signature = model.signature;
    this.smsHeader = model.smsHeader;

    if (this.signature || this.smsHeader)
      this.isShowContainsHeaderOrSign = true;
    else this.isShowContainsHeaderOrSign = false;

    if (this.numbersType == 'isSmartSendSms') {
      this.selectedSmsCp =
        model?.items[0]?.smsCp == SmsCp.MCI
          ? 'mci'
          : model?.items[0]?.smsCp == SmsCp.Irancell
          ? 'irancell'
          : 'rightel';

      this.onChangeMode(this.selectedSmsCp);
    }

    // this.separateSmsBody();
    this.getSmsCount();
    this.emitSmsBody();
  }

  onShowSignature() {
    let smsBody = '';
    // add sms header
    if (this.input_isAddHeader) {
      if (this.isOrganSmsHeaderAtFirst)
        smsBody =
          `${
            this.organizationSmsHeader ? this.organizationSmsHeader + '\n' : ''
          }` +
          `${this.smsHeader ? this.smsHeader + '\n' : ''}` +
          this.smsBody;
      else
        smsBody =
          `${this.smsHeader ? this.smsHeader + '\n' : ''}` +
          `${
            this.organizationSmsHeader ? this.organizationSmsHeader + '\n' : ''
          }` +
          this.smsBody;
    }

    let data = {
      smsBody: smsBody,
      signature: this.signature,
      organizationSignature: this.organizationSignature,
      isOrganSignatureAtFirst: this.isOrganSignatureAtFirst,
    };

    const modalResult = this.dialogService.openModal({
      component: SmsBodySignatureComponent,
      data: data,
    });

    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((result) => {
        if (result) {
          this.signature = result.signature;
          this.organizationSignature = result.organizationSignature;
          this.isOrganSignatureAtFirst = result.isOrganSignatureAtFirst;
          this.getSmsCount();
          this.emitSmsBody();
        }
      });
  }

  onShowHeader() {
    const isExitSignatureInSmsBody = this.smsBody?.includes(this.signature);
    let smsBody = '';

    //add sms signature
    if (this.input_isAddSignature) {
      if (this.isOrganSignatureAtFirst)
        smsBody =
          this.smsBody +
          `${
            this.organizationSignature ? '\n' + this.organizationSignature : ''
          }` +
          `${
            this.signature && !isExitSignatureInSmsBody
              ? '\n' + this.signature
              : ''
          }`;
      else
        smsBody =
          this.smsBody +
          `${
            this.signature && !isExitSignatureInSmsBody
              ? '\n' + this.signature
              : ''
          }` +
          `${
            this.organizationSignature ? '\n' + this.organizationSignature : ''
          }`;
    }

    let data = {
      smsBody: smsBody,
      smsHeader: this.smsHeader,
      organizationSmsHeader: this.organizationSmsHeader,
      isOrganSmsHeaderAtFirst: this.isOrganSmsHeaderAtFirst,
    };

    const modalResult = this.dialogService.openModal({
      component: SmsBodyHeaderComponent,
      data: data,
    });

    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((result) => {
        if (result) {
          this.smsHeader = result.smsHeader;
          this.organizationSmsHeader = result.organizationSmsHeader;
          this.isOrganSmsHeaderAtFirst = result.isOrganSmsHeaderAtFirst;
          this.getSmsCount();
          this.emitSmsBody();
        }
      });
  }

  //#endregion

  getUserState() {
    if (!this.smsBody) this.smsBody = '';
    this.organizationSignature =
      this.permissionService.userState()?.organizationSignature;
    this.organizationSmsHeader =
      this.permissionService.userState()?.organizationSmsHeader;
    this.getSmsCount();
    this.emitSmsBody();
  }

  convertNumbersToggle() {
    this.isConvertToPersianNums = !this.isConvertToPersianNums;
    this.convertSmsBodyNumbers();
  }

  convertSmsBodyNumbers() {
    if (!this.smsBody) return;

    if (this.isConvertToPersianNums)
      this.smsBody = this.utilityService.getTextWithArabicNumber(this.smsBody);
    // else
    //   this.smsBody = this.utilityService.getTextWithEnglishNumber(this.smsBody);

    if (this.smsBody === undefined) this.smsBody = '';

    this.emitSmsBody();
  }

  clearSmsBody() {
    this.smsBody = '';
    this.finalSmsBody = '';
    this.smsLength = 0;
    this.smsCount = 0;
    this.emitSmsBody();
    this.emitSmsCount();
  }

  getSmsCount() {
    this.generateFinalSmsBody();
    this.smsLength = this.finalSmsBody?.length;
    const result = this.utilityService.getSmsPart(
      this.finalSmsBody,
      this.isSmartSend ? 3 : this.sendNumberSelected?.udhLen
    );

    if (result.smsPart > this.smsCount && result.smsPart > 1) {
      this.isChangeSmsCount = true;
      const timeout = setTimeout(() => {
        this.isChangeSmsCount = false;
        clearTimeout(timeout);
      }, 1000);
    }
    this.smsCount = result.smsPart;
    this.remainingCharUntilNextPart = result.remainingChar;

    if (this.smsLength > this.maxSmsBodyCount) {
      this.finalSmsBody = this.finalSmsBody.substring(0, this.maxSmsBodyCount);
      this.smsBody = this.finalSmsBody;
    }
    this.emitSmsCount();
  }

  onShowSmsPreview() {
    this.generateFinalSmsBody();
    const modalResult = this.dialogService.openModal({
      component: SmsPreviewComponent,
      data: {
        finalSmsBody: this.finalSmsBody,
        privateNumber: this.privateNumber,
      },
    });
    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((res) => {});
  }

  onShowSmsTemplate() {
    const modalResult = this.dialogService.openModal({
      component: SmsTemplateModalComponent,
    });
    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((res) => {
        if (res) {
          // + '\n' + this.smsBody;
          this.smsBody = res;
          this.convertSmsBodyNumbers();
          this.getSmsCount();
          this.emitSmsBody();
        }
      });
  }

  onShowShortLinks() {
    const modalResult = this.dialogService.openModal({
      component: ShortLinkModalComponent,
    });
    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((res) => {
        if (res) {
          // + '\n' + this.smsBody;
          this.addTextWithCursor(res);
          this.convertSmsBodyNumbers();
          this.getSmsCount();
          this.emitSmsBody();
        }
      });
  }

  generateFinalSmsBody() {
    // return;
    this.finalSmsBody = '';
    this.finalSmsBody = this.smsBody || '';

    // add sms header
    if (this.input_isAddHeader) {
      if (this.isOrganSmsHeaderAtFirst)
        this.finalSmsBody =
          `${
            this.organizationSmsHeader ? this.organizationSmsHeader + '\n' : ''
          }` +
          `${this.smsHeader ? this.smsHeader + '\n' : ''}` +
          this.finalSmsBody;
      else
        this.finalSmsBody =
          `${this.smsHeader ? this.smsHeader + '\n' : ''}` +
          `${
            this.organizationSmsHeader ? this.organizationSmsHeader + '\n' : ''
          }` +
          this.finalSmsBody;
    }

    let englishSignature = this.utilityService.getTextWithEnglishNumber(
      this.signature
    );
    let persianSignature = this.utilityService.getTextWithArabicNumber(
      this.signature
    );

    const isExitSignatureInSmsBody =
      this.finalSmsBody?.includes(englishSignature) ||
      this.finalSmsBody?.includes(persianSignature);

    //add sms signature
    if (this.input_isAddSignature) {
      if (this.isOrganSignatureAtFirst)
        this.finalSmsBody =
          this.finalSmsBody +
          `${
            this.organizationSignature ? '\n' + this.organizationSignature : ''
          }` +
          `${
            this.signature && !isExitSignatureInSmsBody
              ? '\n' + this.signature
              : ''
          }`;
      else
        this.finalSmsBody =
          this.finalSmsBody +
          `${
            this.signature && !isExitSignatureInSmsBody
              ? '\n' + this.signature
              : ''
          }` +
          `${
            this.organizationSignature ? '\n' + this.organizationSignature : ''
          }`;
    }
  }

  addEmojiToMessage(event) {
    this.addTextWithCursor(event.emoji.native);
  }

  addTextWithCursor(text) {
    const smsbodyElement = this.smsbodyElement();
    const textAreaValue = smsbodyElement?.nativeElement?.value;
    // GET CURRENT CURSOR POSITION
    const oldCursorPos = smsbodyElement?.nativeElement.selectionStart;
    // GET TEXT BEFORE CURSOR POSITION
    let output = textAreaValue.substring(0, oldCursorPos);
    // INSERT Text LETTER IN BETWEEN
    output += text;
    // GET TEXT AFTER CURSOR POSITION
    output += textAreaValue.substring(oldCursorPos, textAreaValue.length);

    this.smsBody = output;

    const timeout = setTimeout(() => {
      const smsbodyElementValue = this.smsbodyElement();
      this.renderer.setProperty(
        smsbodyElementValue.nativeElement,
        'value',
        output
      );

      // this.smsbodyElement.nativeElement.value = output;
      const newCursorPos = oldCursorPos + text?.length;
      smsbodyElementValue.nativeElement.selectionStart = newCursorPos;
      smsbodyElementValue.nativeElement.selectionEnd = newCursorPos;
      smsbodyElementValue.nativeElement.focus();
      clearTimeout(timeout);
    }, 10);

    this.emitSmsBody();
  }

  showForbiddenCharactersDialog() {
    let dialog = document.getElementsByClassName('cdk-global-overlay-wrapper');
    if (dialog?.length == 1) return;
    else if (dialog?.length == 0) {
      if (this.smsBody.includes('\\')) {
        this.dialogService.openDialog({
          title: 'common.error',
          message: this.translateService.instant(
            'messages.forbiddenCharacters',
            {
              forbiddenCharacters: '\\  ',
            }
          ),
          status: DialogStatus.error,
        });
        return;
      }
    }
  }

  emitSmsBody() {
    // this.showForbiddenCharactersDialog();
    this.output_smsBody.emit(this.smsBody);
    this.generateFinalSmsBody();
    if (this.numbersType == 'isSmartSendSms') {
      this.separateSmsBody();
      this.finalSmsBody = this.smsBody;
    }
    this.output_finalSmsBody.emit(this.finalSmsBody);
    this.emitSmsCount();
  }

  emitSmsCount() {
    this.output_smsCount.emit(this.smsCount);
  }

  getVoiceMessages(model: GetVoiceMessagesListDto) {
    this.voiceMessageDetails.voiceMessageId = model.id;
    this.voiceMessageDetails.title = model.name;
    this.emitVoiceMessages();
  }

  emitVoiceMessages() {
    if (!this.voiceMessageDetails?.maxTryCount)
      delete this.voiceMessageDetails?.maxTryCount;
    if (!this.voiceMessageDetails?.minuteBetweenTries)
      delete this.voiceMessageDetails?.minuteBetweenTries;

    if (Object.keys(this.voiceMessageDetails)?.length === 0)
      this.output_VoiceMessageDetails.emit(null);
    else this.output_VoiceMessageDetails.emit(this.voiceMessageDetails);
  }

  getSocialMediaMessages(model: SocialMediaMessageFilesForSendDto) {
    this.socialMediaMessageDetails.socialMediaFileId = model?.id;
    this.emitSocialMediaMessages();
  }

  emitSocialMediaMessages() {
    if (!this.socialMediaMessageDetails?.socialMediaApplicationId)
      delete this.socialMediaMessageDetails?.socialMediaApplicationId;
    if (!this.socialMediaMessageDetails?.socialMediaFileId)
      delete this.socialMediaMessageDetails?.socialMediaFileId;

    if (Object.keys(this.socialMediaMessageDetails)?.length === 0)
      this.output_socialMediaMessageDetails.emit(null);
    else
      this.output_socialMediaMessageDetails.emit(
        this.socialMediaMessageDetails
      );
  }

  getSocialMediaApplications(model: SocialMediaApplicationsListDto) {
    this.socialMediaMessageDetails.socialMediaApplicationId = model?.id;
    this.emitSocialMediaMessages();
  }

  onChangeMode(event) {
    this.selectedSmsCp = event;
    let item;
    if (this.sendNumberSelected)
      switch (event) {
        case 'mci':
          item = this.sendNumberSelected.items.find(
            (item) => item.smsCp == SmsCp.MCI
          );
          this.signature = item?.signature;
          this.smsHeader = item?.smsHeader;
          break;
        case 'irancell':
          item = this.sendNumberSelected.items.find(
            (item) => item.smsCp == SmsCp.Irancell
          );
          this.signature = item?.signature;
          this.smsHeader = item?.smsHeader;
          break;
        case 'rightel':
          item = this.sendNumberSelected.items.find(
            (item) => item.smsCp == SmsCp.Rightel
          );
          this.signature = item?.signature;
          this.smsHeader = item?.smsHeader;
          break;
        default:
          break;
      }
    this.getSmsCount();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
